import axios from 'axios';

const apiNotifications = {
  get() {
    return axios.get(
      `${process.env.VUE_APP_SITEURL}notifications.json?${Date.now()}`
    );
  }
};
export default apiNotifications;
